import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { injectIntl } from 'react-intl';
import { unflatten } from 'flat';
import { reduxForm, FormSection, Field, Fields } from 'redux-form';

import buildModel, { fieldNames, dateYearMonthFieldNames } from './model';
import * as messages from './messages';
import FormError from 'ui/common/form/form-error';

import TextField from 'ui/common/form/fields/text-field';
import YearField from 'ui/common/form/fields/year-field';
import MonthField from 'ui/common/form/fields/month-field';
import CheckboxField from 'ui/common/form/fields/checkbox-field';
import validator from 'ui/common/form/validator';
import SelectField from 'ui/common/form/fields/simple-select-field';

window.validator = validator;
// const baseModel = buildModel({});

function validate(values) {
  const model = buildModel(values);

  const errors = validator(model)(values);
  return unflatten(errors);
}

const gradeOptions = [
  {
    text: 'First Class Honours / Highest Distinction',
    value: 'First Class Honours / Highest Distinction',
  },
  {
    text: 'Second Class (Upper) Honours / Distinction',
    value: 'Second Class (Upper) Honours / Distinction',
  },
  {
    text: 'Second Class (Lower) Honours / Merit',
    value: 'Second Class (Lower) Honours / Merit',
  },
  {
    text: 'Third Class Honours / Honours',
    value: 'Third Class Honours / Honours',
  },
  {
    text: 'Pass',
    value: 'Pass',
  },
  {
    text: 'Bachelors (without Honours)',
    value: 'Bachelors (without Honours)',
  },
];

class EntryForm extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  renderDateYearMonthFields({ year, month, model, parentFieldName, onChange }) {
    const { intl: { locale, formatMessage } } = this.props;

    const yearFieldFullName = `${parentFieldName}.${dateYearMonthFieldNames.year}`;
    const monthFieldFullName = `${parentFieldName}.${dateYearMonthFieldNames.month}`;

    return (
      <div className="row">
        <div className="col-md-12">
          <label>{formatMessage(messages.labels[parentFieldName])}</label>
        </div>

        <div className="col-md-6">
          <YearField
            {...year}
            name={dateYearMonthFieldNames.year}
            min={model[yearFieldFullName].numericality.greaterThanOrEqualTo}
            max={model[yearFieldFullName].numericality.lessThanOrEqualTo}
            label={formatMessage(messages.labels[yearFieldFullName])}
            onChange={onChange}
            showBlankOption
            hideLabel
          />
        </div>
        <div className="col-md-6">
          <MonthField
            {...month}
            name={dateYearMonthFieldNames.month}
            min={model[monthFieldFullName].numericality.greaterThanOrEqualTo}
            max={model[monthFieldFullName].numericality.lessThanOrEqualTo}
            locale={locale}
            label={formatMessage(messages.labels[monthFieldFullName])}
            onChange={onChange}
            showBlankOption
            hideLabel
          />
        </div>
      </div>
    );
  }

  renderTimePeriod({ startDate, endDate, currentlyStudying }) {
    const { intl: { formatMessage } } = this.props;
    const model = buildModel({
      startDate: startDate.input.value,
      endDate: endDate.input.value,
      currentlyStudying: currentlyStudying.input.value,
    });

    return (
      <div className="row py-3">
        <div className="col-md-6">
          <FormSection name={startDate.input.name}>
            <Fields
              names={[dateYearMonthFieldNames.year, dateYearMonthFieldNames.month]}
              component={this.renderDateYearMonthFields}
              model={model}
              parse={Number}
              parentFieldName={startDate.input.name}
            />
          </FormSection>
          <br />
          <CheckboxField
            {...currentlyStudying}
            label={formatMessage(messages.labels.currentlyStudying)}
            size="lg"
            wrapperClassName="pb-3"
          />
        </div>

        <div className="col-md-6">
          {!currentlyStudying.input.value && (
            <FormSection name={endDate.input.name}>
              <Fields
                names={[dateYearMonthFieldNames.year, dateYearMonthFieldNames.month]}
                component={this.renderDateYearMonthFields}
                model={model}
                parse={Number}
                parentFieldName={endDate.input.name}
              />
            </FormSection>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { handleSubmit, form: formName, intl: { formatMessage } } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <FormError formName={formName} />
        <div className="row">
          {/* <div className="col-md-6">
            <Fields
              names={['schoolName', 'schoolId', fieldNames.schoolNameSearch]}
              textFieldName="schoolName"
              valueFieldName="schoolId"
              searchFieldName={fieldNames.schoolNameSearch}
              component={ApiAutoCompleteField}
              label={formatMessage(messages.labels.schoolName)}
              required={baseModel[fieldNames.schoolName].presence}
              apiRequestConfig={autoSuggestSchools}
              apiResponseConfig={{ resultsKey: 'schools', textKey: 'schoolName', valueKey: 'id' }}
            />
          </div> */}
          <div className="col-md-6">
            <Field
              name={fieldNames.schoolName}
              component={TextField}
              label={formatMessage(messages.labels.schoolName)}
            />
          </div>
          <div className="col-md-6">
            <Field
              name={fieldNames.fieldOfStudy}
              component={TextField}
              label={formatMessage(messages.labels.fieldOfStudy)}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <Field
              name={fieldNames.degree}
              component={TextField}
              label={formatMessage(messages.labels.degree)}
            />
          </div>
          <div className="col-md-6">
            <Field
              name={fieldNames.grade}
              component={SelectField}
              options={gradeOptions}
              label={formatMessage(messages.labels.grade)}
              className="mt-4"
              showBlankOption
              hideLabel
            />
          </div>
        </div>

        <div>
          <Field
            name={fieldNames.activities}
            component={TextField}
            multiLine
            rows={5}
            label={formatMessage(messages.labels.activities)}
          />

          <small style={{ fontStyle: 'italic' }}>(Maximum 500 characters allowed)</small>
        </div>

        <Fields
          names={[fieldNames.startDate, fieldNames.endDate, fieldNames.currentlyStudying]}
          component={this.renderTimePeriod}
        />

        <div>
          <Field
            name={fieldNames.description}
            component={TextField}
            multiLine
            rows={5}
            label={formatMessage(messages.labels.description)}
          />
          <small style={{ fontStyle: 'italic' }}>(Maximum 2000 characters allowed)</small>
        </div>
      </form>
    );
  }
}

export default function createForm({ form, initialValues, onSubmit }) {
  const modalSubmit = values => {
    if (!values[fieldNames.schoolName]) {
      values[fieldNames.schoolName] = values[fieldNames.schoolNameSearch];
    }

    delete values[fieldNames.schoolNameSearch];

    onSubmit(values);
  };

  return reduxForm({
    form,
    initialValues,
    validate,
    onSubmit: modalSubmit,
  })(injectIntl(EntryForm));
}



// WEBPACK FOOTER //
// ./src/ui/education/form/index.js